import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaToxicologicaInterface } from "../../../../../interfaces/FechaToxicologicaInterface";
import { ExamenTXInterface } from "../../../../../interfaces/ExamenTXInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ReporteExamenTXListaPrint } from "./ReporteExamenTXListaPrint";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ReporteExamenListaScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "REPORTE EXAMEN TRABAJADOR";
  const { control, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);

  const [] = useState({
    date: "",
    name: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    console.log("Datos guardados:", {
      ...formData,
      images,
    });

    navigate(`/domiciliaria/${evaluadosList_id}`);
  };

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  // Recarga la pagina despues de imprimir o cancelar impresión
  useEffect(() => {
    const handleAfterPrint = () => {
      navigate(`/examenTX/${evaluadosList_id}`, { replace: true });
      window.location.href = `/examenTX/${evaluadosList_id}`;
    };

    // `/examenTX/${evaluadosList_id}`
    // `/toxicologica/${evaluadosList_id}`

    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [navigate, evaluadosList_id]);

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaTX = useGetData<FechaToxicologicaInterface[]>({
    url: `/fecha-toxi/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-toxi"],
  });

  const mutateFechaTX = useMutationData({
    url: `/fecha-toxi/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-toxi"],
  });

  const queryExamenTX = useGetData<ExamenTXInterface>({
    url: `/examentx/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "examentx"],
  });

  const mutateExamenTX = useMutationData({
    url: `/examentx/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "examentx"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryFechaTX.data && queryFechaTX.data.length > 0) {
      const fechatx = queryFechaTX.data[0];
      reset({
        fecha_autorizaciontx: fechatx.fecha_autorizaciontx || "",
      });
    }
  }, [queryFechaTX.data, reset]);

  const [selectedMotivo, setSelectedMotivo] = useState<string | null>(null);
  const [selectedSalud, setSelectedSalud] = useState<string | null>(null);
  const [selectedMedicamentos, setSelectedMedicamentos] = useState<
    string | null
  >(null);
  const [selectedRango, setSelectedRango] = useState<string | null>(null);
  const [selectedMarihuana, setSelectedMarihuana] = useState<string | null>(
    null
  );
  const [selectedCocaina, setSelectedCocaina] = useState<string | null>(null);
  const [selectedOpiaceos, setSelectedOpiaceos] = useState<string | null>(null);
  const [selectedAnfetamina, setSelectedAnfetamina] = useState<string | null>(
    null
  );
  const [selectedMetanfetamina, setSelectedMetanfetamina] = useState<
    string | null
  >(null);
  const [selectedBenzodiacepina, setSelectedBenzodiacepina] = useState<
    string | null
  >(null);

  useEffect(() => {
    if (queryExamenTX.data) {
      reset({
        folio_tx: queryExamenTX.data.folio_tx || "",
        nombrecentro_trabajotx: queryExamenTX.data.nombrecentro_trabajotx || "",
        domicilio_trabajotx: queryExamenTX.data.domicilio_trabajotx || "",
        motivo_trabajotx: queryExamenTX.data.motivo_trabajotx || "",
        identifica_tx: queryExamenTX.data.identifica_tx || "",
        estado_saludtx: queryExamenTX.data.estado_saludtx || "",
        tomar_medicamentostx: queryExamenTX.data.tomar_medicamentostx || "",
        nombre_medicamentotx: queryExamenTX.data.nombre_medicamentotx || "",
        porque_medicamentotx: queryExamenTX.data.porque_medicamentotx || "",
        panel_multidrogastx: queryExamenTX.data.panel_multidrogastx || "",
        vaso_multidrogastx: queryExamenTX.data.vaso_multidrogastx || "",
        temperatura_tx: queryExamenTX.data.temperatura_tx || "",
        rango_normaltx: queryExamenTX.data.rango_normaltx || "",
        marihuanatx: queryExamenTX.data.marihuanatx || "",
        cocainatx: queryExamenTX.data.cocainatx || "",
        opiaceostx: queryExamenTX.data.opiaceostx || "",
        anfetaminatx: queryExamenTX.data.anfetaminatx || "",
        metanfetaminatx: queryExamenTX.data.metanfetaminatx || "",
        benzodiacepinatx: queryExamenTX.data.benzodiacepinatx || "",
        lotetx: queryExamenTX.data.lotetx || "",
        fecha_caducidadtx: queryExamenTX.data.fecha_caducidadtx || "",
        nombre_recolectortx: queryExamenTX.data.nombre_recolectortx || "",
        evaluado_uuid: queryExamenTX.data.evaluado_uuid || "",
      });
      setSelectedMotivo(queryExamenTX.data.motivo_trabajotx || null);
      setSelectedSalud(queryExamenTX.data.estado_saludtx || null);
      setSelectedMedicamentos(
        queryExamenTX.data.tomar_medicamentostx ? "true" : "false"
      );
      setSelectedRango(queryExamenTX.data.rango_normaltx ? "true" : "false");
      setSelectedMarihuana(queryExamenTX.data.marihuanatx || null);
      setSelectedCocaina(queryExamenTX.data.cocainatx || null);
      setSelectedOpiaceos(queryExamenTX.data.opiaceostx || null);
      setSelectedAnfetamina(queryExamenTX.data.anfetaminatx || null);
      setSelectedMetanfetamina(queryExamenTX.data.metanfetaminatx || null);
      setSelectedBenzodiacepina(queryExamenTX.data.benzodiacepinatx || null);
    }
  }, [queryExamenTX.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  console.log("Valor: ", selectedMotivo);

  const renderPage1 = () => (
    <div className="space-y-4 p-4">
      {/* Table section */}
      <div>
        <table className="w-full text-sm border-collapse border border-slate-700">
          <tbody>
            <tr>
              {/* Columna izquierda: título */}
              <td className="w-1/2 border-2 border-slate-700 text-center font-semibold bg-customCyan">
                TRABAJADOR / REPORTE EXÁMEN
                <br />
                (Prevención de sustancias de abuso)
              </td>
              {/* Columna derecha: contenido */}
              <td className="w-1/2 border-2 border-slate-700 text-left">
                <div className="flex items-center space-x-4 p-2">
                  <Label className="flex-shrink-0">
                    No. DE CONTROL O FOLIO:
                  </Label>
                  <Controller
                    name="folio_tx"
                    control={control}
                    defaultValue={queryExamenTX.data?.folio_tx || ""}
                    render={({ field }) => (
                      <TextInput
                        id="folio_tx"
                        type="text"
                        className="w-40px"
                        {...field}
                        value={field.value}
                        onChange={(e) => field.onChange(e.target.value)}
                        disabled={true}
                      />
                    )}
                  />
                </div>
                <div className="flex items-center space-x-4 p-2">
                  <Label className="flex-shrink-0">FECHA:</Label>
                  <Controller
                    name="fecha_examentx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="fecha_examentx"
                        type="date"
                        {...field}
                        value={
                          field.value ||
                          (queryFechaTX.data && queryFechaTX.data.length > 0
                            ? queryFechaTX.data[0]?.fecha_examentx || ""
                            : "")
                        }
                        disabled={true}
                      />
                    )}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <h4 className="text-left">MODULO I.-EMPRESA</h4>
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700">
            <tbody>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  NOMBRE DEL CENTRO DE TRABAJO:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="nombrecentro_trabajotx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="nombrecentro_trabajotx"
                        type="text"
                        {...field}
                        value={queryExamenTX.data?.nombrecentro_trabajotx}
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  DOMICILIO:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="domicilio_trabajotx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="domicilio_trabajotx"
                        type="text"
                        {...field}
                        value={queryExamenTX.data?.domicilio_trabajotx}
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  CON BASE A LA NOM-030-STPS-2009 Y EL REGLAMENTO FEDERAL DE
                  SEGURIDAD Y SALUD EN EL TRABAJO, SE REALIZA EL EXÁMEN PARA LA
                  PREVENCIÓN DE TOXICOMANIAS EN EL CENTRO DE TRABAJO POR:
                  <br />
                  {/* Radio buttons centrados y con más espacio entre ellos */}
                  <div className="flex justify-center space-x-8 mt-4">
                    <label>
                      <Controller
                        name="motivo_trabajotx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="motivo_trabajotx"
                            type="radio"
                            {...field}
                            name="motivo_trabajotx"
                            value="Nuevo Ingreso"
                            disabled={true}
                            checked={selectedMotivo === "Nuevo Ingreso"}
                            onChange={() => {
                              field.onChange("Nuevo Ingreso");
                              setSelectedMotivo("Nuevo Ingreso");
                            }}
                          />
                        )}
                      />{" "}
                      NUEVO INGRESO
                    </label>
                    <label>
                      <Controller
                        name="motivo_trabajotx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="motivo_trabajotx"
                            type="radio"
                            {...field}
                            name="motivo_trabajotx"
                            value="Programa Preventivo"
                            disabled={true}
                            checked={selectedMotivo === "Programa Preventivo"}
                            onChange={() => {
                              field.onChange("Programa Preventivo");
                              setSelectedMotivo("Programa Preventivo");
                            }}
                          />
                        )}
                      />{" "}
                      PROGRAMA PREVENTIVO
                    </label>
                    <label>
                      <Controller
                        name="motivo_trabajotx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="motivo_trabajotx"
                            type="radio"
                            {...field}
                            name="motivo_trabajotx"
                            value="Otro"
                            disabled={true}
                            checked={selectedMotivo === "Otro"}
                            onChange={() => {
                              field.onChange("Otro");
                              setSelectedMotivo("Otro");
                            }}
                          />
                        )}
                      />{" "}
                      OTRO
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[25px]"></div>
        <h4 className="text-left">MODULO II.- TRABAJADOR</h4>
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700">
            <tbody>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  NOMBRE DEL EVALUADO:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Label
                    value={`${queryEvaluado.data?.nombre || ""} ${
                      queryEvaluado.data?.apellido_paterno || ""
                    } ${queryEvaluado.data?.apellido_materno || ""}`}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  EMPRESA EN LA QUE LABORA:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Label
                    value={queryEvaluado.data?.empresa_id?.nombre || ""}
                  ></Label>
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  FECHA DE NACIMIENTO:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Label
                    value={
                      queryEvaluado.data?.fecha_nacimiento
                        ? (() => {
                            const [year, month, day] =
                              queryEvaluado.data.fecha_nacimiento.split("-");
                            return `${day}/${month}/${year}`;
                          })()
                        : ""
                    }
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  SE IDENTIFICA CON:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="identifica_tx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="identifica_tx"
                        type="text"
                        {...field}
                        value={queryExamenTX.data?.identifica_tx}
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  MANIFIESTO QUE MI ESTADO DE SALUD EN GENERAL ES:
                  <br />
                  {/* Radio buttons centrados y con más espacio entre ellos */}
                  <div className="flex justify-center space-x-8 mt-4">
                    <label>
                      <Controller
                        name="estado_saludtx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estado_saludtx"
                            type="radio"
                            {...field}
                            name="estado_saludtx"
                            value="Bueno"
                            disabled={true}
                            checked={selectedSalud === "Bueno"}
                            onChange={() => {
                              field.onChange("Bueno");
                              setSelectedSalud("Bueno");
                            }}
                          />
                        )}
                      />{" "}
                      BUENO
                    </label>
                    <label>
                      <Controller
                        name="estado_saludtx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estado_saludtx"
                            type="radio"
                            {...field}
                            name="estado_saludtx"
                            value="Regular"
                            disabled={true}
                            checked={selectedSalud === "Regular"}
                            onChange={() => {
                              field.onChange("Regular");
                              setSelectedSalud("Regular");
                            }}
                          />
                        )}
                      />{" "}
                      REGULAR
                    </label>
                    <label>
                      <Controller
                        name="estado_saludtx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estado_saludtx"
                            type="radio"
                            {...field}
                            name="estado_saludtx"
                            value="Malo"
                            disabled={true}
                            checked={selectedSalud === "Malo"}
                            onChange={() => {
                              field.onChange("Malo");
                              setSelectedSalud("Malo");
                            }}
                          />
                        )}
                      />{" "}
                      MALO
                    </label>
                    <label>
                      <Controller
                        name="estado_saludtx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estado_saludtx"
                            type="radio"
                            {...field}
                            name="estado_saludtx"
                            value="Con Problemas Crónicos"
                            disabled={true}
                            checked={selectedSalud === "Con Problemas Crónicos"}
                            onChange={() => {
                              field.onChange("Con Problemas Crónicos");
                              setSelectedSalud("Con Problemas Crónicos");
                            }}
                          />
                        )}
                      />{" "}
                      CON PROBLEMAS CRÓNICOS
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  EN LOS ÚLTIMOS 30 DÍAS HE TOMADO MEDICAMENTOS:
                  <br />
                  {/* Radio buttons centrados y con más espacio entre ellos */}
                  <div className="flex justify-center space-x-8 mt-4">
                    <label>
                      <Controller
                        name="tomar_medicamentostx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="tomar_medicamentostx"
                            type="radio"
                            {...field}
                            name="tomar_medicamentostx"
                            value="true"
                            disabled={true}
                            checked={selectedMedicamentos === "true"}
                            onChange={() => {
                              field.onChange("true");
                              setSelectedMedicamentos("true");
                            }}
                          />
                        )}
                      />{" "}
                      SI
                    </label>
                    <label>
                      <Controller
                        name="tomar_medicamentostx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="tomar_medicamentostx"
                            type="radio"
                            {...field}
                            name="tomar_medicamentostx"
                            value="false"
                            disabled={true}
                            checked={selectedMedicamentos === "false"}
                            onChange={() => {
                              field.onChange("false");
                              setSelectedMedicamentos("false");
                            }}
                          />
                        )}
                      />{" "}
                      NO
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  EN CASO AFIRMATIVO, DESCRIBA EL NOMBRE DEL MEDICAMENTO(S) Y
                  PORQUE LOS TOMÓ:
                  <br />
                  <div>
                    <Controller
                      name="nombre_medicamentotx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="nombre_medicamentotx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.nombre_medicamentotx}
                          disabled={true}
                          placeholder="Nombre de los medicamentos..."
                        />
                      )}
                    />
                    <br />
                    <Controller
                      name="porque_medicamentotx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <textarea
                          id="porque_medicamentotx"
                          {...field}
                          value={queryExamenTX.data?.porque_medicamentotx}
                          disabled={true}
                          style={isDarkMode ? {
                            backgroundColor: '#374151',
                            color: '#e5e7eb',
                            borderColor: '#4b5563'
                          } : {}}
                          className={`w-full h-32 p-3 border-2 rounded-md resize-none focus:outline-none focus:ring-2 ${isDarkMode ? "border-gray-600 bg-gray-700 text-gray-200 focus:ring-blue-500" : "border-slate-700 bg-white text-gray-800 focus:ring-customCyan"}`}
                          placeholder="Escriba aquí el porque..."
                        />
                      )}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[25px]"></div>
        <h4 className="text-left">MODULO III.- AUTORIZACIÓN DEL TRABAJADOR</h4>
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700">
            <tbody>
              <tr>
                {/* Columna única que abarca ambas columnas */}
                <td
                  colSpan={2}
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                >
                  <div className="text-justify">
                    EL QUE SUSCRIBE{" "}
                    <Label
                      value={`${queryEvaluado.data?.nombre || ""} ${
                        queryEvaluado.data?.apellido_paterno || ""
                      } ${queryEvaluado.data?.apellido_materno || ""}`}
                      className="inline-block w-auto uppercase font-bold"
                    />{" "}
                    MANIFIESTO QUE LEÍ EL MODULO I DESCRITO EN ESTE FORMATO Y
                    AUTORIZO LA REALIZACIÓN DEL ANÁLISIS CLÍNICO, PARA LO CUAL
                    DONO UNA MUESTRA DE ORINA, VERIFICANDO PREVIAMENTE QUE EL
                    REACTIVO Y RECIPIENTE RECOLECTOR SON NUEVOS, ESTÁN SELLADOS
                    Y SU FECHA DE CADUCIDAD ES VIGENTE. ASIMISMO, DOY MI
                    CONSENTIMIENTO PARA ENVIAR ESTA MUESTRA DE ORINA A UN
                    LABORATORIO EN CASO DE OBTENER UN RESULTADO “NO NEGATIVO” Y
                    SEA REQUERIDA UNA PRUEBA CONFIRMATORIA. ASIMISMO; AUTORIZO A
                    LA EMPRESA SKA TRACKING AND SECURITY S.A. DE C.V. PARA QUE
                    PROPORCIONE TODA LA INFORMACIÓN, DOCUMENTOS Y TODA LA
                    INFORMACIÓN QUE DERIVEN DE LAS EVALUACIONES DE PRUEBAS DE
                    CONFIANZA QUE SE ME REALICEN.
                    <div className="mt-[50px]"></div>
                    <h5 className="text-center">
                      _____________________
                      <br />
                      Firma del Evaluado
                    </h5>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[25px]"></div>
        <h4 className="text-left">
          MODULO IV.- METODO DE DETECCIÓN (USO EXCLUSIVO DE LA EMPRESA)
        </h4>
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700 table-fixed">
            <tbody>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  PANEL MULTIDROGAS DE:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="panel_multidrogastx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="panel_multidrogastx"
                        type="text"
                        {...field}
                        value={queryExamenTX.data?.panel_multidrogastx}
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  VASO MULTIDROGAS DE:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="vaso_multidrogastx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="vaso_multidrogastx"
                        type="text"
                        {...field}
                        value={queryExamenTX.data?.vaso_multidrogastx}
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/3 border-2 border-slate-700 text-left font-semibold">
                  TEMPERATURA:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/3 border-2 border-slate-700 text-left font-semibold">
                  <Controller
                    name="temperatura_tx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="temperatura_tx"
                        type="text"
                        {...field}
                        value={queryExamenTX.data?.temperatura_tx}
                        disabled={true}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  RANGO NORMAL:
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                  <div className="flex justify-center space-x-8">
                    <label>
                      <Controller
                        name="rango_normaltx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="rango_normaltx"
                            type="radio"
                            {...field}
                            name="rango_normaltx"
                            value="true"
                            disabled={true}
                            checked={selectedRango === "true"}
                            onChange={() => {
                              field.onChange("true");
                              setSelectedRango("true");
                            }}
                          />
                        )}
                      />{" "}
                      SI
                    </label>
                    <label>
                      <Controller
                        name="rango_normaltx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="rango_normaltx"
                            type="radio"
                            {...field}
                            name="rango_normaltx"
                            value="false"
                            disabled={true}
                            checked={selectedRango === "false"}
                            onChange={() => {
                              field.onChange("false");
                              setSelectedRango("false");
                            }}
                          />
                        )}
                      />{" "}
                      NO
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-[25px]"></div>
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700 table-fixed">
            <thead>
              <tr>
                <th className="border-2 border-slate-700 text-left font-semibold p-2">
                  RESULTADO
                </th>
                <th className="border-2 border-slate-700 text-left font-semibold p-2">
                  PRUEBA EMPLEADA
                </th>
                <th className="border-2 border-slate-700 text-left font-semibold p-2">
                  DATOS DEL RECOLECTOR
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Fila de "Resultado" con tres celdas */}
              <tr>
                <td className="border-2 border-slate-700">
                  <table className="w-full">
                    <tbody>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          No.
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          DROGA
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          ( + )
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          ( - )
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          1
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          MARIHUANA (THC)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="marihuanatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="marihuanatx"
                                type="radio"
                                {...field}
                                name="marihuanatx"
                                value="Positivo"
                                disabled={true}
                                checked={selectedMarihuana === "Positivo"}
                                onChange={() => {
                                  field.onChange("Positivo");
                                  setSelectedMarihuana("Positivo");
                                }}
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="marihuanatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="marihuanatx"
                                type="radio"
                                {...field}
                                name="marihuanatx"
                                value="Negativo"
                                disabled={true}
                                checked={selectedMarihuana === "Negativo"}
                                onChange={() => {
                                  field.onChange("Negativo");
                                  setSelectedMarihuana("Negativo");
                                }}
                              />
                            )}
                          />
                        </td>
                      </tr>

                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          2
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          COCAINA (COC)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="cocainatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="cocainatx"
                                type="radio"
                                {...field}
                                name="cocainatx"
                                value="Positivo"
                                disabled={true}
                                checked={selectedCocaina === "Positivo"}
                                onChange={() => {
                                  field.onChange("Positivo");
                                  setSelectedCocaina("Positivo");
                                }}
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="cocainatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="cocainatx"
                                type="radio"
                                {...field}
                                name="cocainatx"
                                value="Negativo"
                                disabled={true}
                                checked={selectedCocaina === "Negativo"}
                                onChange={() => {
                                  field.onChange("Negativo");
                                  setSelectedCocaina("Negativo");
                                }}
                              />
                            )}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          3
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          OPIACEOS (OPI)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="opiaceostx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="opiaceostx"
                                type="radio"
                                {...field}
                                name="opiaceostx"
                                value="Positivo"
                                disabled={true}
                                checked={selectedOpiaceos === "Positivo"}
                                onChange={() => {
                                  field.onChange("Positivo");
                                  setSelectedOpiaceos("Positivo");
                                }}
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="opiaceostx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="opiaceostx"
                                type="radio"
                                {...field}
                                name="opiaceostx"
                                value="Negativo"
                                disabled={true}
                                checked={selectedOpiaceos === "Negativo"}
                                onChange={() => {
                                  field.onChange("Negativo");
                                  setSelectedOpiaceos("Negativo");
                                }}
                              />
                            )}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          4
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          ANFETAMINA (AMP)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="anfetaminatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="anfetaminatx"
                                type="radio"
                                {...field}
                                name="anfetaminatx"
                                value="Positivo"
                                disabled={true}
                                checked={selectedAnfetamina === "Positivo"}
                                onChange={() => {
                                  field.onChange("Positivo");
                                  setSelectedAnfetamina("Positivo");
                                }}
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="anfetaminatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="anfetaminatx"
                                type="radio"
                                {...field}
                                name="anfetaminatx"
                                value="Negativo"
                                disabled={true}
                                checked={selectedAnfetamina === "Negativo"}
                                onChange={() => {
                                  field.onChange("Negativo");
                                  setSelectedAnfetamina("Negativo");
                                }}
                              />
                            )}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          5
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          METANFETAMINA (mAMP)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="metanfetaminatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="metanfetaminatx"
                                type="radio"
                                {...field}
                                name="metanfetaminatx"
                                value="Positivo"
                                disabled={true}
                                checked={selectedMetanfetamina === "Positivo"}
                                onChange={() => {
                                  field.onChange("Positivo");
                                  setSelectedMetanfetamina("Positivo");
                                }}
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="metanfetaminatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="metanfetaminatx"
                                type="radio"
                                {...field}
                                name="metanfetaminatx"
                                value="Negativo"
                                disabled={true}
                                checked={selectedMetanfetamina === "Negativo"}
                                onChange={() => {
                                  field.onChange("Negativo");
                                  setSelectedMetanfetamina("Negativo");
                                }}
                              />
                            )}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-2 border-slate-700 text-left">
                          6
                        </td>
                        <td className="border-2 border-slate-700 text-left">
                          BENZODIACEPINA (BZO)
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="benzodiacepinatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="benzodiacepinatx"
                                type="radio"
                                {...field}
                                name="benzodiacepinatx"
                                value="Positivo"
                                disabled={true}
                                checked={selectedBenzodiacepina === "Positivo"}
                                onChange={() => {
                                  field.onChange("Positivo");
                                  setSelectedBenzodiacepina("Positivo");
                                }}
                              />
                            )}
                          />
                        </td>
                        <td className="border-2 border-slate-700 text-center">
                          <Controller
                            name="benzodiacepinatx"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <input
                                id="benzodiacepinatx"
                                type="radio"
                                {...field}
                                name="benzodiacepinatx"
                                value="Negativo"
                                disabled={true}
                                checked={selectedBenzodiacepina === "Negativo"}
                                onChange={() => {
                                  field.onChange("Negativo");
                                  setSelectedBenzodiacepina("Negativo");
                                }}
                              />
                            )}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                {/* Fila de "Prueba Empleada" con celda combinada que abarca toda la columna */}
                <td
                  className="border-2 border-slate-700 text-left font-semibold p-2"
                  rowSpan={7}
                >
                  <Label>No. LOTE:</Label>
                  <Controller
                    name="lotetx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="lotetx"
                        type="text"
                        {...field}
                        value={queryExamenTX.data?.lotetx}
                        disabled={true}
                      />
                    )}
                  />
                  <div className="mt-[25px]"></div>
                  <Label>FECHA CADUCIDAD:</Label>
                  <Controller
                    name="fecha_caducidadtx"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="fecha_caducidadtx"
                        type="date"
                        {...field}
                        value={queryExamenTX.data?.fecha_caducidadtx}
                        disabled={true}
                      />
                    )}
                  />
                </td>
                {/* Fila de "Datos del recolector" con celda combinada que abarca toda la columna */}
                <td
                  className="border-2 border-slate-700 font-semibold p-2"
                  rowSpan={7}
                >
                  <div className="text-center">
                    <Controller
                      name="nombre_recolectortx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="nombre_recolectortx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.nombre_recolectortx}
                          disabled={true}
                        />
                      )}
                    />
                    <Label className="text-center">
                      _______________________________
                    </Label>
                    <br />
                    <Label>Nombre</Label>
                  </div>
                  <br />
                  <div className="text-center">
                    <Label className="text-center">
                      _______________________________
                    </Label>
                    <br />
                    <Label>Firma</Label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}
        onSubmit={handleSubmit}
      >
        {renderHeader()}

        {currentPage === 1 && renderPage1()}

        <div className="mt-6 p-4 flex justify-between">
          {/* Botón Cancelar en renderPage1 (lado izquierdo) */}
          {currentPage === 1 && (
            <Button
              color="red"
              className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/toxicologica/${evaluadosList_id}`);
              }}
            >
              Cancelar
            </Button>
          )}

          {currentPage > 1 && (
            <Button
              color="blue"
              onClick={() => {
                window.scrollTo(0, 0);
                handlePageChange(currentPage - 1);
              }}
            >
              Anterior
            </Button>
          )}

          {/* Botón Guardar */}
          {currentPage === 1 && (
            <div className="flex space-x-4">
              <Button color="blue" onClick={handlePrint}>
                Imprimir
              </Button>
              <button
                type="button"
                className="bg-red-500 text-white rounded px-4 py-2"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/toxicologica/${evaluadosList_id}`);
                }}
              >
                Salir
              </button>
            </div>
          )}
        </div>
      </form>
      {/* Imprimir */}
      <div id="printableContent" style={{ display: "none" }}>
        <ReporteExamenTXListaPrint />
      </div>
    </div>
  </div>
  );
};
